const breakpoints = {
  sm: "700px",
  md: "992px",
  lg: "1440px",
  xl: "1900px",
  "2xl": "2200px",
};

export default breakpoints;
